import {
  Component,
  Inject,
  OnInit,
  Optional,
  EventEmitter,
  Output,
  OnDestroy
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { TranslationService } from '@alfresco/adf-core';

import { NodeEntry, Node } from '@alfresco/js-api';
import { Observable, of, Subject } from 'rxjs';


import { takeUntil, map, catchError, mergeMap, tap} from 'rxjs/operators';
import { DocuServeConfigurationService } from '../../services/docuserve-configuration.service';
import { AppStore, SnackbarErrorAction } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { FileModel } from '@alfresco/adf-content-services';
import { ContentApiService } from '@alfresco/aca-shared';


@Component({
  selector: 'aca-uploader-plus',
  templateUrl: './uploader-plus.component.html',
  styleUrls: ['./uploader-plus.component.scss']
})
export class UploaderPlusComponent implements OnInit, OnDestroy {
  isLinear = false;
  forms: FormGroup[] = [];
  parentNode!: Node;
  files!: FileModel[];
  applyToAllFiles: boolean = false;
  onDestroy$: Subject<boolean> = new Subject<boolean>();

  visibilityLevelList: any = [];
  documentTypes: any = ["unknown"];
  allowedDuplicateDocumentTypes: string[] = [];

  /** Emitted when the edit/create template give error for example a folder with same name already exist*/
  @Output()
  error: EventEmitter<any> = new EventEmitter<any>();

  /** Emitted when the edit/create template is successfully created/mmodified     */
  @Output()
  success: EventEmitter<any> = new EventEmitter<NodeEntry>();

  // list of unique document types set for all forms
  uniqueDuplicates: any[] = [];
  duplicateFileNames!: string;

  constructor(
    private formBuilder: FormBuilder,
    private dialog: MatDialogRef<UploaderPlusComponent>,
    private translation: TranslationService,
    private configService: DocuServeConfigurationService,
    private store: Store<AppStore>,
    private contentApi: ContentApiService,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {
    console.log('Entered uploader plus component with data', data);
    if (data) {
      this.parentNode = data.node;
      this.files = data.files || this.files;
    }

  }


  ngOnInit() {

    //console.log("ParentNode", this.parentNode);

    if(this.parentNode && this.parentNode.path &&  this.parentNode.path.elements && this.parentNode?.nodeType === "ch:categoryFolder"){
      // throw a message saying you cannot do this as its not in a categoryfolder


      this.configService.getAppConfig().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
        console.log("Got the app config file data", data);
        console.log("ParentNode", this.parentNode);
        if(this.parentNode?.path?.elements){
          let functionKey: typeof data = this.parentNode.path?.elements[this.parentNode.path?.elements.length - 1].name;
          let categoryKey: typeof data = this.parentNode.name;

          //console.log("categoryKey", categoryKey);

          //this.documentTypes = data.metadata[functionKey]['ajg:documentType'];
          this.documentTypes = data.metadata['ch:documentType'][functionKey][categoryKey];

        }
        console.log("documentType List", this.documentTypes);
        this.allowedDuplicateDocumentTypes = data.allowedDuplicateDocumentTypes;

        //console.log("allowedDuplicateDocumentTypes List", this.allowedDuplicateDocumentTypes);
      });

    }else {
        this.documentTypes = ["unknown"];
    }

    const { files } = this;

    //console.log('Files', files);

    let name = '';
    let documentType = '';

    for (let index in files) {
      if (files[index]) {
        name = files[index] ? files[index].name : '';
      }

      this.forms.push(
        this.formBuilder.group({
          name: [name],
          documentType: [documentType],
        })
      );
    }
  }

  get editing(): boolean {
    return !!this.data.files;
  }

  getName(index: number): string {
    let { name } = this.forms[index].value;
    return (name || '').trim();
  }

  getDocumentType(index: number): string {
    let { documentType } = this.forms[index].value;
    return (documentType || '').trim();
  }


  private getProperties(): any[] {
    //const { name, description, documentType } = this;

    let propertyList = [];
    const firstForm = this.forms[0];

    for (let index in this.forms) {
      const form = this.forms[index];

      let documentType = this.applyToAllFiles
        ? firstForm.get('documentType')?.value
        : form.get('documentType')?.value;


      var props = {
        'cm:name': form.get('name')?.value,
        'ch:documentType': documentType,
      };

      propertyList.push(props);
    }

    //console.log("getProperties", propertyList);

    return propertyList;
  }

  // check each form is valid
  formsValid(): boolean {
    for (let index in this.forms) {
      if (!this.forms[index].valid) {
        return false;
      }
    }

    return true;
  }

  private edit(): Observable<any> {
    const propertiesList = this.getProperties();

    //console.log('Document properties List', propertiesList);

    return of(propertiesList);
  }

  submit() {
    const { forms, dialog, editing } = this;

    for (let index in forms) {
      if (!forms[index].valid || !editing) {
        return;
      }
    }

    this.edit()
      .pipe(
        takeUntil(this.onDestroy$),
        mergeMap((result) => {
          const duplicates = this.findDuplicateDocumentTypes(result);
          const filteredDuplicates = this.removeAllowedDuplicateDocumentTypes(duplicates);
          if (filteredDuplicates.length > 0) {
            var fileNames: string[] = [];
            filteredDuplicates.forEach((item) => {
              fileNames.push(item['cm:name']);
            });
            this.duplicateFileNames = fileNames.join(', ');
            throw new Error('Duplicate document type filenames ' + this.duplicateFileNames);
          }
          return this.findDuplicatesInParent(result).pipe(map((duplicatesFoundInParent) => {
            if (duplicatesFoundInParent.length > 0) {
              // handle duplicates here
              var fileNames: string[] = [];
              duplicatesFoundInParent.forEach((item) => {
                fileNames.push(item['cm:name']);
              });

              this.duplicateFileNames = fileNames.join(', ');
              throw new Error('Target folder duplicate document type filenames ' + this.duplicateFileNames);
            }
            return result;
          }));
        }),
        tap((result) => {
            console.log('Event dialog upload document form result', result);
            this.success.emit(result);
            dialog.close(result);
        }),
        catchError((err : Error) => {
          // Handle the error in catchError operator
          console.error('Caught an error:', err);
          if(err.message.startsWith("Duplicate document type filenames ")){
              this.store.dispatch(new SnackbarErrorAction('APP.JOB-DOCUMENTS.MESSAGES.ERRORS.DOCUMENT-TYPE-CONFLICT-FORM', {
                fileNames: this.duplicateFileNames
              }));
            }else {
              this.store.dispatch(
                new SnackbarErrorAction('APP.JOB-DOCUMENTS.MESSAGES.ERRORS.DOCUMENT-TYPE-CONFLICT', {
                  fileNames: this.duplicateFileNames
                })
              );
            }

          return of(null);
        })
      )
      .subscribe();
  }

  handleError(error: any): any {
    console.log("Upload error ", error);
    let errorMessage = 'CORE.MESSAGES.ERRORS.GENERIC';

    try {
      const {
        error: { statusCode }
      } = JSON.parse(error.message);

      if (statusCode === 409) {
        errorMessage =
          'APP.FILE_UPLOAD.ERRORS.409';
      }
    } catch (err) {
      /* Do nothing, keep the original message */
    }

    this.error.emit(this.translation.instant(errorMessage));

    return error;
  }

  /**
   * Apply same metadata to all files
   *
   */
  applyToAll(_event: any) {
    // toggle applyAll boolean
    this.applyToAllFiles = !this.applyToAllFiles;

    //console.log('applyToAllFiles ', this.applyToAllFiles);
    for (let index in this.forms) {
      if (index != '0') {
        //console.log('update validators');

        if (this.applyToAllFiles) {
          //this.forms[index].get("documentType").setValidators(null);
          this.forms[index].get('documentType')?.disable();
        } else {
          this.forms[index].get('documentType')?.enable();
        }
      }
    }
  }

  /**
   * Reset al the forms to blank values
   *
   *
   */

  resetForms() {
    for (let index in this.forms) {
      let form = this.forms[index];
      form.get('documentType')?.reset();
      this.applyToAllFiles = false;
    }
  }
  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  findDuplicateDocumentTypes(arr: any[]): any[] {
    // Use a Map to count occurrences of names
    const nameCountMap = new Map<string, number>();

    // Count occurrences
    arr.forEach(item => {
      //console.log("item", item);
      const count = nameCountMap.get(item["ch:documentType"]) || 0;
      nameCountMap.set(item["ch:documentType"], count + 1);
    });

    //console.log("nameCountMap", nameCountMap);

    // Find items with duplicate names
    const duplicates = arr.filter(item => nameCountMap.get(item["ch:documentType"])! > 1);

    //console.log("findDuplicateDocumentTypes duplicates", duplicates);

    return duplicates;
  }

  /**
   *
   * @param duplicates
   */
  removeAllowedDuplicateDocumentTypes(duplicates: any[]) {

    //console.log("Duplicates before", duplicates)
    let categoryKey = this.parentNode.name;


    let filteredDuplicates = duplicates.filter(item => {
      //console.log("Filter ", categoryKey + "_" + item["ch:documentType"]);
      return !this.allowedDuplicateDocumentTypes.includes(categoryKey + "_" + item["ch:documentType"])});

    //console.log("duplicates After", filteredDuplicates );

    return filteredDuplicates
  }
  
  private findDuplicatesInParent(result: any[]): Observable<any[]> {
    return this.contentApi.getNodeChildren(this.parentNode?.id ?? '').pipe(
      map((children) => {
        const existingFiles = children?.list?.entries ?? [];
        const duplicateFiles: any[] = [];

        for (const uploadedDoc of result ?? []) {
          const uploadedType = uploadedDoc?.['ch:documentType'];
          if (!uploadedType) continue;

          const existingMatch = existingFiles.find((file: any) => file?.entry?.properties?.['ch:documentType'] === uploadedType);

          const isAllowedDuplicate = this.allowedDuplicateDocumentTypes.includes(`${this.parentNode?.name ?? 'UnknownNode'}_${uploadedType}`);

          if (existingMatch && !isAllowedDuplicate) {
            duplicateFiles.push(uploadedDoc);
          }
        }

        return duplicateFiles;
      })
    );
  }


}




